<template>
  <div class="flex flex-col gap-24">
    <div class="w-full hidden md:flex flex-col gap-8">
      <div class="w-4/5 h-50 bg-grey-300 animate-pulse rounded mr-8" />
      <div class="w-1/5 h-50 bg-grey-300 animate-pulse rounded mr-8" />
    </div>
    <div class="w-full flex md:hidden flex-col gap-8">
      <div class="w-full h-30 bg-grey-300 animate-pulse rounded mr-8" />
      <div class="w-full h-30 bg-grey-300 animate-pulse rounded mr-8" />
      <div class="w-3/5 h-30 bg-grey-300 animate-pulse rounded mr-8" />
    </div>
    <DoctorSkeletonLoader :count="1" class="w-full" />

    <div class="w-full flex flex-row gap-24">
      <div
        class="w-16 h-16 rounded-full border-2 border-grey-300 bg-grey-100 animate-pulse self-center"
      />
      <div class="w-2/5 h-20 bg-grey-300 animate-pulse rounded mr-8" />
    </div>
    <div class="w-full flex flex-row gap-24">
      <div
        class="w-16 h-16 rounded-full border-2 border-grey-300 bg-grey-100 animate-pulse self-center"
      />
      <div class="w-2/5 h-20 bg-grey-300 animate-pulse rounded mr-8" />
    </div>
  </div>
</template>

<script>
import DoctorSkeletonLoader from './DoctorSkeletonLoader.vue'

export default {
  name: 'QuestionSkeletonLoader',
  components: {
    DoctorSkeletonLoader,
  },
}
</script>
